module.exports = __webpack_public_path__ + "img/head.7255bbd5.png";